module.exports = __webpack_public_path__ + "static/media/group@2x.3d91ba75.png";